/**
 * OAuth Provider Registry
 *
 * Single source of truth for OAuth provider configurations.
 * To add a new provider, add an entry here with the appropriate endpoint and credential extraction.
 */

export const OAuthProviders = {
    'google-ads-offline-conversions-api-s2s': {
        type: 'google',
        authEndpoint: '/adwordsauthorize',
        displayName: 'Google Ads',
        extractCredentials: accessToken => ({
            loginId: accessToken.login_email,
            refreshToken: accessToken.refresh_token,
        }),
    },
    'google-ads-web': {
        type: 'google',
        authEndpoint: '/adwordsauthorize',
        displayName: 'Google Ads',
        extractCredentials: accessToken => ({
            loginId: accessToken.login_email,
            refreshToken: accessToken.refresh_token,
        }),
    },
    'snap-conversions-api-s2s': {
        type: 'snap',
        authEndpoint: '/snapchatauthorize',
        displayName: 'Snapchat',
        extractCredentials: accessToken => ({
            loginId: accessToken.login_email,
            refreshToken: accessToken.refresh_token,
        }),
    },
    'microsoft-ads-conversions-api-s2s': {
        type: 'microsoft',
        authEndpoint: '/bingauthorize',
        displayName: 'Microsoft Ads',
        extractCredentials: accessToken => ({
            loginId: accessToken.login_email,
            refreshToken: accessToken.refresh_token,
        }),
    },
};

export const getOAuthProvider = partnerName => OAuthProviders[partnerName] || null;
